import { gql } from "@apollo/client";export default gql`query contentAggregate($where: collection_content_bool_exp) {
    contentAggregate: collection_content_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
